import clsx from 'clsx'

export type TBoxProps = {
  children: React.ReactNode
  className?: string
}
export const Box: React.FC<TBoxProps> = ({ children, className = '' }) => {
  return (
    <div
      className={clsx(
        'border border-border-color-default rounded-12 bg-surface-color-default',
        className,
      )}
    >
      {children}
    </div>
  )
}
